module.exports = __webpack_public_path__ + "static/drunk-tank-pink-7e5e5a624beab4c5ab7651653c961c0d.jpg";